export const appointmentStatus = Object.freeze({
  SCHEDULED: { name: "Scheduled", value: "scheduled" },
  RESCHEDULED: { name: "Rescheduled", value: "rescheduled" },
  IN_PROGRESS: { name: "In Progress", value: "in_progress" },
  COMPLETED: { name: "Completed", value: "completed" },
  CANCELED: { name: "Cancelled", value: "canceled" },
  AUTOCOMPLETED: { name: "Autocompleted", value: "autocompleted" },
  NO_SHOW: { name: "No Show", value: "no_show" },
});

export const getAppointmentStatusName = {
  [appointmentStatus.SCHEDULED.value]: appointmentStatus.SCHEDULED.name,
  [appointmentStatus.RESCHEDULED.value]: appointmentStatus.RESCHEDULED.name,
  [appointmentStatus.IN_PROGRESS.value]: appointmentStatus.IN_PROGRESS.name,
  [appointmentStatus.COMPLETED.value]: appointmentStatus.COMPLETED.name,
  [appointmentStatus.CANCELED.value]: appointmentStatus.CANCELED.name,
  [appointmentStatus.AUTOCOMPLETED.value]: appointmentStatus.AUTOCOMPLETED.name,
  [appointmentStatus.NO_SHOW.value]: appointmentStatus.NO_SHOW.name,
};

export const insuranceStatus = Object.freeze({
  PENDING: { name: "Pending", value: "PENDING" },
  APPROVED: { name: "Approved", value: "APPROVED" },
  REJECTED: { name: "Rejected", value: "REJECTED" },
});

export const invoiceStatus = Object.freeze({
  PAID: { name: "Paid", value: "Paid" },
  PENDING: { name: "New", value: "New" },
  OVERDUE: { name: "Overdue", value: "Overdue" },
});

export const getInvoiceStatusName = {
  [invoiceStatus.PAID.value]: invoiceStatus.PAID.name,
  [invoiceStatus.PENDING.value]: invoiceStatus.PENDING.name,
  [invoiceStatus.OVERDUE.value]: invoiceStatus.OVERDUE.name,
};

export const genderType = Object.freeze({
  MALE: { name: "Male", value: "male" },
  FEMALE: { name: "Female", value: "female" },
  OTHER: { name: "Other", value: "other" },
});

export default class GlobalData {
  static BLOOD_GROUPS = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
  static DAYS = [
    {
      value: 1,
      label: "Sun",
    },
    {
      value: 2,
      label: "Mon",
    },
    {
      value: 3,
      label: "Tue",
    },
    {
      value: 4,
      label: "Wed",
    },
    {
      value: 5,
      label: "Thu",
    },
    {
      value: 6,
      label: "Fri",
    },
    {
      value: 7,
      label: "Sat",
    },
  ];

  static HOURS = [
    "00",
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "21",
    "22",
    "23",
  ];

  static MINUTES = [
    "00",
    "05",
    "10",
    "15",
    "20",
    "25",
    "30",
    "35",
    "40",
    "45",
    "50",
    "55",
  ];

  static PAYMENT_TYPE = [
    "Cash",
    "UPI",
    "Cheque",
    "Net Banking",
    "Credit/Debit Card",
  ];

  static NUMBER_OF_OVERLAPPING_SLOTS = [1, 2, 3, 4, 5];

  static TREATMENT_CATEGORY_LIST = ["Dental"];

  static VALUE_TYPE=["NUMERIC","SINGLE_LINE"]

  static MEDICINE_CATEGORY_LIST = ["Ayurveda", "Allopathy"];

}

export let payTabIndex = 0;

export function payTabIndexFun(param) {
  payTabIndex = param;

  return payTabIndex;
}

export const validUnits = [
  "day",
  "month",
  "year",
  "hours",
  "minutes",
  "seconds",
  "weeks",
];

export const validOperators = ["+", "-"];

export let defaultClientDetailsTab = "Prescriptions/Case Papers";

const listeners = new Set();

export function clientDetailsTabFun(param) {
  defaultClientDetailsTab = param;
  listeners.forEach((fn) => fn(param));
}

export function subscribeToTabChanges(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}



export const PRESCRIPTION_CASE_PAPER = "Prescriptions/Case Papers";
export const REPORTS = 'Reports';
export const PAYMENTS = 'Payments';
export const PACKAGES = "ServicePackage";
export const CREDIT_WALLET = "Credit Wallet";
export const REFUNDS = "Refunds";
export const MEDICAL_PROCEDURES = "Medical Procedures";
export const ACCEPTED_CONSENTS = "Accepted Consents";
export const GROWTH_CHART = "Growth Chart";
export const IMMUNIZATION_SCHEDULE = "Immunization Schedule";
export const CERTIFICATES = "Certificates";




export const hospitalizationStatus = Object.freeze({
  SCHEDULED_ADMISSION: {
    name: "Scheduled Admission",
    value: "SCHEDULED_ADMISSION",
  },
  ADMITTED: { name: "Admitted", value: "ADMITTED" },
  DISCHARGED: { name: "Discharged", value: "DISCHARGED" },
  TRANSFERRED: { name: "Transferred", value: "TRANSFERRED" },
  AMA: { name: "Against Medical Advice", value: "AMA" },
  ABSCONDED: { name: "Absconded", value: "ABSCONDED" },
  EXPIRED: { name: "Expired", value: "EXPIRED" },
  CANCELLED: { name: "Cancelled", value: "CANCELLED" },
});

export const getHospitalizationStatusName = {
  [hospitalizationStatus.SCHEDULED_ADMISSION.value]:
    hospitalizationStatus.SCHEDULED_ADMISSION.name,
  [hospitalizationStatus.ADMITTED.value]: hospitalizationStatus.ADMITTED.name,
  [hospitalizationStatus.DISCHARGED.value]:
    hospitalizationStatus.DISCHARGED.name,
  [hospitalizationStatus.TRANSFERRED.value]:
    hospitalizationStatus.TRANSFERRED.name,
  [hospitalizationStatus.AMA.value]: hospitalizationStatus.AMA.name,
  [hospitalizationStatus.ABSCONDED.value]: hospitalizationStatus.ABSCONDED.name,
  [hospitalizationStatus.EXPIRED.value]: hospitalizationStatus.EXPIRED.name,
  [hospitalizationStatus.CANCELLED.value]: hospitalizationStatus.CANCELLED.name,
};

export const hospitalizationType = Object.freeze({
  NORMAL: { name: "Normal", value: "NORMAL" },
  EMERGENCY: { name: "Emergency", value: "EMERGENCY" },
});

export const dischargeOptions = [
  {
    value: "DISCHARGED",
    label: "DISCHARGED",
    reason: "Patient's condition improved, and they are fit for discharge.",
  },
  {
    value: "TRANSFERRED",
    label: "TRANSFERRED",
    reason:
      "Patient requires specialized care and has been moved to another facility.",
  },
  {
    value: "AMA",
    label: "AMA (Against Medical Advice)",
    reason: "Patient chose to leave the hospital despite medical advice.",
  },
  {
    value: "ABSCONDED",
    label: "ABSCONDED",
    reason:
      "Patient left the hospital without informing staff or completing treatment.",
  },
  {
    value: "EXPIRED",
    label: "EXPIRED",
    reason: "Patient passed away due to medical complications.",
  },
];

export const Transaction = [
  "PURCHASE",
  "SALE",
  "RETURN",
  "STOCK_REFILL",
  "STOCK_REDUCED",
];

export const TransactionTypes = Object.freeze({
  PURCHASE: { name: "Purchase", value: "Purchase" },
  SALE: { name: "Sale", value: "Sale" },
  RETURN: { name: "Return", value: "Return" },
  STOCK_REFILL: { name: "Stock Refill", value: "Stock Refill" },
  STOCK_REDUCED: { name: "Stock Reduced", value: "Stock Reduced" },
});

export const StatusTypes = Object.freeze({
  EXPIRED: { name: "Expired", value: "Expired" },
  NONEXPIRED: { name: "Non Expired", value: "nonExpired" },
});

export const BatchColumnFilter = Object.freeze({
  SALES: { name: "Sales", value: "Sales" },
  BUYING: { name: "Buying", value: "Buying" },
});

export const INVOICE_STAMP_OPTIONS = [
    { value: "COMPANY_STAMP", label: "Company Stamp" },
    { value: "SERVICE_PROVIDER_STAMP", label: "Service Provider Stamp" },
  ];
